<!-- Listado de aliados -->
<div *ngIf="restaurant">
  <div class="row mb-2" *ngFor="let partner of listPartners">
    <div class="col">
      <div class="card" [ngStyle]="{'border-color': menu.color}">
        <img class="card-img-top" [src]="partner.logo" alt="Card image cap">
        <div class="card-body">
          <h2 class="card-title" class="card-title {{menu.fontHeader}}" [ngStyle]="{'color': menu.colorText}">{{ partner.name | titlecase }}</h2>
          <p class="card-text">{{ partner.address }}</p>
          <div class="row">
            <div class="col d-flex justify-content-around">
              <a [href]="linkInstagram(partner)" target="_blank">
                <h3 class="{{menu.fontText}}"> <i class="fab fa-instagram"></i>
                </h3>
              </a>
              <a [href]="linkWs(partner)" target="_blank" *ngIf="partner.phone">
                <h3 class="{{menu.fontText}}"> <i class="fab fa-whatsapp"></i>
                </h3>
              </a>
              <a [href]="linkAddress(partner)" target="_blank">
                <h3 class="{{menu.fontText}}"> <i class="fas fa-map-marker-alt"></i>
                </h3>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>